import { computed } from 'vue'
import { useCurrentSession } from '../../../composables/useCurrentSession'
export function useConsolePrincipal() {
  const { state } = useCurrentSession()
  return computed(() => state.status === 'authenticated' ? state.session?.userId ?? '' : '')
}
